import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export const tooltipTemplate = (
  stylecontext: string,
  node: HTMLElement,
) => html`<one-popover cloak context="${stylecontext}" placement="bottom">
    <one-link as="span" color="prominent" strong>${node.innerText}</one-link>
    <div slot="content">
      ${unsafeHTML(node.title)}
    </div>
  </one-popover>`;

export default tooltipTemplate;
